export const arcList = [
  "木叶篇",
  "波之国篇",
  "中忍考试篇",
  "木叶崩溃篇",
  "佐助夺还篇",
  "风影夺还篇",
  "晓篇",
];

export const episodes = [
  {
    id: "ep-001",
    number: 1,
    title: "旋涡鸣人登场！",
    arc: "木叶篇",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20cel%20shaded%20scene%20of%20a%20small%20hidden%20ninja%20village%20at%20sunset%20with%20wooden%20buildings%20and%20a%20giant%20carved%20mountain%20face%2C%20warm%20orange%20sky%2C%20a%20young%20ninja%20silhouette%20on%20a%20rooftop%2C%20simplified%20clean%20background%2C%20high%20detail%2C%20vibrant%20colors&width=900&height=560&seq=ep-001-cover&orientation=landscape",
    summary:
      "故事从木叶隐村展开，调皮捣蛋的少年鸣人在村子里四处惹祸，被村民疏远的他却始终渴望得到认可。",
    story: [
      "在木叶隐村，一个总被村民冷眼相待的少年四处涂鸦火影岩，他就是漩涡鸣人。因为体内封印着曾袭击村子的九尾妖狐，鸣人从小便承受着孤独与疏远。",
      "为了吸引他人的注意，鸣人不断搞恶作剧，却在伊鲁卡老师的耐心与关怀下，第一次感受到被接纳的温暖。这一集为整部作品奠定了「渴望被认可」的情感基调。",
      "随着剧情推进，鸣人偷走了封印卷轴，也在与伊鲁卡的并肩作战中明白了忍者的责任，由此正式踏上成为火影的道路。",
    ],
    characters: ["naruto", "kakashi"],
    duration: "23 分钟",
    airDate: "2002-10-03",
  },
  {
    id: "ep-002",
    number: 2,
    title: "我的名字是旋涡鸣人！",
    arc: "木叶篇",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20cel%20shaded%20scene%20of%20a%20young%20ninja%20standing%20with%20his%20teacher%20in%20a%20forested%20training%20ground%2C%20morning%20light%20through%20green%20leaves%2C%20determined%20expressions%2C%20simplified%20clean%20background%2C%20high%20detail%2C%20vibrant%20colors&width=900&height=560&seq=ep-002-cover&orientation=landscape",
    summary:
      "鸣人从忍者学校毕业，与佐助、小樱组成第七班，在卡卡西的考验中第一次真正体会团队的意义。",
    story: [
      "经过努力，鸣人终于从忍者学校毕业，并与同届第一的佐助、理论扎实的小樱一同被编入第七班。",
      "指导上忍卡卡西用铃铛抢夺考验三人，表面上是一场测试，实际上是在教他们「团队合作比个人实力更重要」。",
      "鸣人从最初的莽撞逐渐明白同伴的珍贵，第七班也由此凝聚成此后贯穿全篇的羁绊。",
    ],
    characters: ["naruto", "sasuke", "sakura", "kakashi"],
    duration: "23 分钟",
    airDate: "2002-10-10",
  },
  {
    id: "ep-003",
    number: 19,
    title: "宿敌！？佐助与鸣人",
    arc: "波之国篇",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20cel%20shaded%20scene%20of%20two%20young%20ninjas%20facing%20each%20other%20on%20a%20misty%20bridge%2C%20tense%20atmosphere%2C%20cool%20grey%20and%20teal%20tones%2C%20dramatic%20composition%2C%20simplified%20clean%20background%2C%20high%20detail&width=900&height=560&seq=ep-003-cover&orientation=landscape",
    summary:
      "第七班护送造桥师前往波之国，途中遭遇雾隐叛忍再不斩与少年白，鸣人与佐助在实战中迅速成长。",
    story: [
      "第七班接下护送造桥师达兹纳的任务，前往被黑帮控制的波之国。途中他们遭遇了被称为「鬼人」的雾隐叛忍桃地再不斩。",
      "面对远超自身等级的对手，卡卡西展现出拷贝忍者的实力，而鸣人与佐助也在生死关头第一次真正并肩作战。",
      "再不斩的同伴少年白以其冰遁血继限界登场，为后续关于「力量与守护」的探讨埋下伏笔。",
    ],
    characters: ["naruto", "sasuke", "sakura", "kakashi"],
    duration: "23 分钟",
    airDate: "2003-02-13",
  },
  {
    id: "ep-004",
    number: 25,
    title: "为了梦想而战！白的真实身份",
    arc: "波之国篇",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20cel%20shaded%20scene%20of%20a%20young%20ninja%20in%20a%20serene%20ice%20mirror%20forest%2C%20soft%20blue%20and%20white%20light%2C%20melancholic%20mood%2C%20simplified%20clean%20background%2C%20high%20detail%2C%20emotional%20atmosphere&width=900&height=560&seq=ep-004-cover&orientation=landscape",
    summary:
      "白以冰遁血继限界困住佐助，鸣人在愤怒与悲痛中爆发出九尾之力，波之国的战斗迎来悲情结局。",
    story: [
      "白施展秘术「魔镜冰晶」，将佐助困于由冰镜构成的牢笼之中，战斗陷入绝境。",
      "鸣人以为佐助已死，愤怒之下第一次引动体内九尾的查克拉，爆发出惊人的力量击破冰镜。",
      "白最终为保护再不斩而牺牲，这段关于「守护重要之人」的故事深深触动了鸣人，也让他重新思考忍者的意义。",
    ],
    characters: ["naruto", "sasuke", "kakashi"],
    duration: "23 分钟",
    airDate: "2003-04-10",
  },
  {
    id: "ep-005",
    number: 34,
    title: "中忍考试开始！",
    arc: "中忍考试篇",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20cel%20shaded%20scene%20of%20many%20young%20ninjas%20gathered%20in%20a%20large%20exam%20hall%2C%20tense%20competitive%20atmosphere%2C%20warm%20indoor%20lighting%2C%20simplified%20clean%20background%2C%20high%20detail%2C%20vibrant%20colors&width=900&height=560&seq=ep-005-cover&orientation=landscape",
    summary:
      "各国忍者齐聚木叶参加中忍考试，鸣人与同伴们在第一场笔试中面对意想不到的规则考验。",
    story: [
      "中忍考试正式拉开帷幕，来自木叶与其他村子的年轻忍者齐聚一堂，气氛剑拔弩张。",
      "第一场是笔试，看似考察知识，实则考验情报搜集与心理素质，考官的规则让考生们各显神通。",
      "鸣人虽然一题不会，却凭借「绝不放弃」的意志通过了这场另类的考核，也为后续的淘汰赛埋下伏笔。",
    ],
    characters: ["naruto", "sasuke", "sakura", "shikamaru", "hinata"],
    duration: "23 分钟",
    airDate: "2003-08-06",
  },
  {
    id: "ep-006",
    number: 47,
    title: "森林中的死斗！第二场考试",
    arc: "中忍考试篇",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20cel%20shaded%20scene%20of%20a%20dense%20dark%20forest%20with%20ninjas%20hiding%20among%20trees%2C%20misty%20green%20tones%2C%20suspenseful%20mood%2C%20simplified%20clean%20background%2C%20high%20detail&width=900&height=560&seq=ep-006-cover&orientation=landscape",
    summary:
      "第二场考试在死亡森林展开，考生需在天数内夺取卷轴，第七班遭遇大蛇丸的袭击，佐助被种下咒印。",
    story: [
      "第二场考试在被称为「死亡森林」的演习场进行，考生必须在限定时间内夺取敌对的天地卷轴。",
      "第七班在途中遭到伪装身份的传说忍者大蛇丸袭击，佐助被施加了危险的咒印，队伍陷入危机。",
      "小樱在关键时刻独自守护昏迷的同伴，剪去长发挺身而出，展现出此前未曾显露的坚韧。",
    ],
    characters: ["naruto", "sasuke", "sakura", "orochimaru"],
    duration: "23 分钟",
    airDate: "2003-10-08",
  },
  {
    id: "ep-007",
    number: 68,
    title: "木叶崩溃计划",
    arc: "木叶崩溃篇",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20cel%20shaded%20scene%20of%20a%20ninja%20village%20under%20attack%20with%20smoke%20and%20broken%20rooftops%2C%20dramatic%20stormy%20sky%2C%20tense%20war%20atmosphere%2C%20simplified%20clean%20background%2C%20high%20detail%2C%20muted%20warm%20tones&width=900&height=560&seq=ep-007-cover&orientation=landscape",
    summary:
      "大蛇丸联合砂隐村发动木叶崩溃计划，村子陷入战火，三代火影被迫迎战自己的旧日弟子。",
    story: [
      "在中忍考试决赛期间，大蛇丸与砂隐村里应外合发动「木叶崩溃计划」，村子瞬间陷入战火。",
      "卡卡西等上忍各自迎敌，鸣人与伙伴们也被卷入残酷的实战之中。",
      "年迈的三代火影为了保护村子，不得不与昔日弟子展开决斗，木叶面临前所未有的存亡危机。",
    ],
    characters: ["naruto", "kakashi", "orochimaru", "gaara"],
    duration: "23 分钟",
    airDate: "2004-05-12",
  },
  {
    id: "ep-008",
    number: 79,
    title: "三代火影的最后",
    arc: "木叶崩溃篇",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20cel%20shaded%20scene%20of%20an%20elderly%20ninja%20clad%20in%20ceremonial%20robes%20facing%20a%20giant%20serpent%20summon%20on%20a%20rooftop%2C%20dramatic%20golden%20light%2C%20epic%20emotional%20mood%2C%20simplified%20clean%20background%2C%20high%20detail&width=900&height=560&seq=ep-008-cover&orientation=landscape",
    summary:
      "三代火影以封邪法印舍身封印大蛇丸的双手，用生命守护了村子，木叶失去了慈祥的领袖。",
    story: [
      "面对大蛇丸召唤的巨大蛇形查克拉实体，三代火影在体力耗尽的绝境中仍不肯退让。",
      "他施展禁术「尸鬼封尽」，以自己的灵魂为代价封印了大蛇丸的双手，剥夺了对方使用忍术的能力。",
      "三代目火影用生命守护了木叶，他的离去让全村陷入哀伤，也让鸣人第一次直面「守护」二字的重量。",
    ],
    characters: ["kakashi", "orochimaru", "naruto"],
    duration: "23 分钟",
    airDate: "2004-05-26",
  },
  {
    id: "ep-009",
    number: 129,
    title: "佐助的决断！",
    arc: "佐助夺还篇",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20cel%20shaded%20scene%20of%20a%20lone%20ninja%20walking%20away%20from%20a%20village%20gate%20at%20night%20under%20a%20full%20moon%2C%20cold%20blue%20grey%20tones%2C%20lonely%20melancholic%20mood%2C%20simplified%20clean%20background%2C%20high%20detail&width=900&height=560&seq=ep-009-cover&orientation=landscape",
    summary:
      "为了获得足以复仇的力量，佐助决定离开木叶投奔大蛇丸，小樱的挽留也无法改变他的心意。",
    story: [
      "在与鸣人的多次交锋与自我怀疑后，佐助认定木叶无法给予他复仇所需的力量，决心离村追随大蛇丸。",
      "小樱在村口苦苦挽留，甚至愿意为他不惜一切，但佐助的心意已决，只留下「谢谢你」的告别。",
      "接到消息的鸣人立刻集结同伴组成追回小队，一场关于羁绊与选择的长途追击就此展开。",
    ],
    characters: ["sasuke", "sakura", "naruto", "shikamaru"],
    duration: "23 分钟",
    airDate: "2005-04-06",
  },
  {
    id: "ep-010",
    number: 133,
    title: "终结之谷的对决",
    arc: "佐助夺还篇",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20cel%20shaded%20scene%20of%20two%20ninjas%20clashing%20over%20a%20waterfall%20between%20two%20giant%20stone%20statues%2C%20sparks%20and%20energy%20swirling%2C%20dramatic%20dark%20blue%20and%20orange%20sky%2C%20epic%20mood%2C%20simplified%20clean%20background%2C%20high%20detail&width=900&height=560&seq=ep-010-cover&orientation=landscape",
    summary:
      "鸣人与佐助在终结之谷展开宿命对决，九尾之力对上咒印二阶段，最终谁也无法真正留住对方。",
    story: [
      "鸣人终于在终结之谷追上佐助，两人在初代火影与斑的巨像之间爆发了宿命般的对决。",
      "鸣人释放九尾查克拉，佐助则进入咒印第二阶段，两人倾尽全力只为证明各自的活法。",
      "战斗以佐助的胜出告终，他留下昏迷的鸣人独自离去。这段分别成为两人羁绊中最深的伤痕。",
    ],
    characters: ["naruto", "sasuke"],
    duration: "23 分钟",
    airDate: "2005-04-20",
  },
  {
    id: "ep-011",
    number: 221,
    title: "归来的鸣人！",
    arc: "风影夺还篇",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20cel%20shaded%20scene%20of%20a%20grown%20up%20young%20ninja%20returning%20to%20his%20village%20gate%20in%20bright%20daylight%2C%20warm%20optimistic%20tones%2C%20hopeful%20mood%2C%20simplified%20clean%20background%2C%20high%20detail%2C%20vibrant%20colors&width=900&height=560&seq=ep-011-cover&orientation=landscape",
    summary:
      "两年半后，随自来也修行的鸣人重返木叶，昔日伙伴都已成长为中忍上忍，新的故事就此开启。",
    story: [
      "历经两年半的修行，鸣人随自来也回到木叶，身高与实力都不可同日而语。",
      "昔日的同伴们都已成为中忍甚至上忍，小樱也成长为出色的医疗忍者，重聚的场景令人感慨。",
      "与此同时，砂隐村的风影我爱罗遭到晓组织袭击，新的危机将众人再次卷入战斗。",
    ],
    characters: ["naruto", "sakura", "kakashi", "gaara", "jiraiya"],
    duration: "23 分钟",
    airDate: "2007-02-15",
  },
  {
    id: "ep-012",
    number: 236,
    title: "晓的威胁",
    arc: "晓篇",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20cel%20shaded%20scene%20of%20a%20group%20of%20cloaked%20figures%20with%20glowing%20red%20cloud%20patterns%20standing%20on%20a%20rocky%20cliff%20at%20stormy%20dusk%2C%20ominous%20powerful%20atmosphere%2C%20simplified%20clean%20background%2C%20high%20detail&width=900&height=560&seq=ep-012-cover&orientation=landscape",
    summary:
      "神秘组织晓开始公开行动，逐一猎捕尾兽人柱力，鸣人与我爱罗都成为他们的目标。",
    story: [
      "以红云黑袍为标志的晓组织逐渐浮出水面，他们的目标直指九大尾兽与人柱力。",
      "我爱罗因体内的一尾而被晓成员掳走，砂隐村向木叶求援，鸣人一行人火速赶往前线。",
      "随着战斗的深入，晓组织强大而冷酷的真面目逐渐揭晓，忍界即将迎来更大的风暴。",
    ],
    characters: ["naruto", "pain", "itachi", "gaara", "kakashi"],
    duration: "23 分钟",
    airDate: "2007-04-19",
  },
];